"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabIndicator = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
var _layout = require("../layout");
var _useAnimateTabIndicator = require("./hooks/useAnimateTabIndicator");
const _excluded = ["width", "x", "background", "testID"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const MotionBox = (0, _framerMotion.m)(_layout.Box);
const TabIndicator = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)((_ref, forwardedRef) => {
  let width = _ref.width,
    x = _ref.x,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'background' : _ref$background,
    testID = _ref.testID,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _useAnimateTabIndicat = (0, _useAnimateTabIndicator.useAnimateTabIndicator)({
      width,
      x
    }),
    widthMotionProps = _useAnimateTabIndicat.widthMotionProps,
    xMotionProps = _useAnimateTabIndicat.xMotionProps;
  return /*#__PURE__*/_react.default.createElement(_layout.Box, _extends({
    ref: forwardedRef,
    testID: testID
  }, props), /*#__PURE__*/_react.default.createElement(MotionBox, {
    animate: xMotionProps.animate,
    background: "primary",
    height: 2,
    initial: false,
    overflow: "hidden",
    testID: "cds-tab-indicator-inner-bar-container",
    transition: xMotionProps.transition,
    width: width
  }, /*#__PURE__*/_react.default.createElement(MotionBox, {
    animate: widthMotionProps.animate,
    background: background,
    height: 2,
    initial: false,
    testID: "cds-tab-indicator-inner-bar",
    transition: widthMotionProps.transition,
    width: "100%"
  })));
}));
exports.TabIndicator = TabIndicator;
TabIndicator.displayName = 'TabIndicator';